import { render, staticRenderFns } from "./RevenueView.vue?vue&type=template&id=9580f000"
import script from "./RevenueView.vue?vue&type=script&lang=js"
export * from "./RevenueView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports